import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import DealerListing from "../../components/DealerListing";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

//Redux

import * as sessionActions from "../../redux/dealers/actions";
import * as branchActions from "../../redux/branch/actions";

//Components

import BranchCreate from "../../components/CustomForm";
import DealerDetail from "../../components/DealerDetail";
import PartnersList from "../../components/PartnersList";
import TestimonialsList from "../../components/TestimonialsList";
import AddNewTestimonial from "../../components/AddNewTestimonial";
import PartnerPersonalInformation from "../../components/PartnerPersonalInformation";
import Rentals from "../../components/Rentals";

class Home extends Component {
  render() {
    let { page } = this.props.match.params;
    switch (page) {
      case "list":
        return <PartnersList />;
      case "rentals":
        return <Rentals />;
        case "rentals-update":
        return <PartnerPersonalInformation />;
      case "personal-information":
        return <PartnerPersonalInformation />;
      default:
        return null;
    }
  }
}

export default Home;
